var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg)}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.email)}})])}
var staticRenderFns = []

export { render, staticRenderFns }